import { User } from "@phosphor-icons/react";

import LeadNotes from "common/components/leads/LeadNotes";
import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import ProfileImage from "common/components/ui/ProfileImage";
import { getProfileSubtitle } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { Lead } from "common/types";

export default function NotesDialog({
  lead,
  isOpen,
  onClose,
}: {
  lead: Lead;
  isOpen: boolean;
  onClose: () => void;
}) {
  const isTabletOrDesktop = useTwBreakpoint("md");

  const Component = isTabletOrDesktop ? Dialog : Drawer;
  const Content = isTabletOrDesktop ? DialogContent : DrawerContent;

  return (
    <Component
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Content size="lg">
        <DialogTitle className="mb-8">Notes</DialogTitle>
        <div className="mb-3.5 flex gap-x-2 rounded-2xl bg-black-50 p-4">
          <ProfileImage src={lead.picture_url} />
          <div className="flex flex-col gap-y-0.5 overflow-x-hidden">
            <span className="text-sm-bold">{lead.full_name}</span>
            <span className="truncate text-xs text-black-500">
              {getProfileSubtitle(lead)}
            </span>
          </div>
          <Button
            variant="secondary-black"
            intent="labelIcon"
            className="ml-auto"
          >
            <User />
          </Button>
        </div>
        <LeadNotes notes={lead.notes} profileId={lead.id} />
      </Content>
    </Component>
  );
}
